export const tokens = {
  site: { name: "site.name" },
  common: {
    discover_brand: "common.discover_brand",
    discover_brands: {
      title: "common.brands.title",
      summary: "common.brands.summary",
    },
    buttons: {
      readMore: "common.buttons.read_more",
    },
  },
  commitment: {
    title: "commitment.title",
    paragraph: "commitment.paragraph",
  },
  about: {
    title: "about.title",
    paragraph: "about.paragraph",
    page: {
      title: "about.page.title",
      paragraph: "about.page.paragraph",
      button: "about.page.button",
      hero: "about.page.hero",
      card1: "about.page.card1",
      card2: {
        title: "about.page.card2.title",
        paragraph: "about.page.card2.paragraph",
      },
      card3: {
        title: "about.page.card3.title",
        paragraph: "about.page.card3.paragraph",
      },
      card4: {
        title: "about.page.card4.title",
        paragraph: "about.page.card4.paragraph",
      },

      values: {
        title: "about.page.values.title",
        value1: {
          title: "value1.title",
          paragraph: "value1.paragraph",
        },
        value2: {
          title: "value2.title",
          paragraph: "value2.paragraph",
        },
        value3: {
          title: "value3.title",
          paragraph: "value3.paragraph",
        },
        value4: {
          title: "value4.title",
          paragraph: "value4.paragraph",
        },
        value5: {
          title: "value5.title",
          paragraph: "value5.paragraph",
        },
        value6: {
          title: "value6.title",
          paragraph: "value6.paragraph",
        },
      },
      product: {
        title: "product.title",
        subtitle: "product.subtitle",
        paragraph: "product.paragraph",
      },
    },
  },
  contact: {
    form: {
      title: {
        mr: "contact.form.title.mr",
        mrs: "contact.form.title.mrs",
      },
      firstName: "contact.form.firstName",
      lastName: "contact.form.lastName",
      organization: "contact.form.organization",
      phone: "contact.form.phone",
      country: "contact.form.country",
      interested_in: "contact.form.interested_in",
      message: "contact.form.message",
      terms: "contact.form.terms",
      terms_prefix: "contact.form.terms.prefix",
      terms_link: "contact.form.terms.link",
      update: "contact.form.update",
      send: "contact.form.send",
    },
    info: {
      contact_info: "contact.info.contact_info",
      title1: "contact.info.title1",
      title2: "contact.info.title2",
      address: "contact.info.address",
      address_info_city: "contact.info.address.city",
      address_info_street: "contact.info.address.street",
      email: "contact.info.email",
      whatsapp: "contact.info.whatsapp",
      phone: "contact.info.phone",
    },
    hero: {
      paragraph: "contact.hero.paragraph",
    },
  },
  cards: {
    card1: {
      title: "cards.card1.title",
      paragraph: "cards.card1.paragraph",
    },
    card2: {
      title: "cards.card2.title",
      paragraph: "cards.card2.paragraph",
    },
    card3: {
      title: "cards.card3.title",
      paragraph: "cards.card3.paragraph",
    },
    card4: {
      title: "cards.card4.title",
      paragraph: "cards.card4.paragraph",
    },
   
  
  },
  nav: {
    home: "nav.home",
    contact: "nav.contact",
    about: "nav.about",
    vision: "nav.vision",
    brands: "nav.brands",
  },
  terms: {
    page: {
      title: "terms.page.title",
      lastUpdated: "terms.page.lastUpdated",
      introduction: {
        title: "terms.page.introduction.title",
        content: "terms.page.introduction.content",
      },
      acceptance: {
        title: "terms.page.acceptance.title",
        content: "terms.page.acceptance.content",
      },
      services: {
        title: "terms.page.services.title",
        content: "terms.page.services.content",
      },
      privacy: {
        title: "terms.page.privacy.title",
        content: "terms.page.privacy.content",
      },
      liability: {
        title: "terms.page.liability.title",
        content: "terms.page.liability.content",
      },
      modifications: {
        title: "terms.page.modifications.title",
        content: "terms.page.modifications.content",
      },
      contact: {
        title: "terms.page.contact.title",
        content: "terms.page.contact.content",
      },
    },
  },
  brands: {
    our_collection: {
      title: "brands.our_collection.title",
      title1: "brands.our_collection.title1",
      paragraph: "brands.our_collection.paragraph",
      paragraph2: "brands.our_collection.paragraph2",
      paragraph3: "brands.our_collection.paragraph3",
      face: "brands.our_collection.face",
      body: "brands.our_collection.body",
    },
    ksurgery: {
      buttonText:"brands.ksurgery.buttonText",

      title: "brands.ksurgery.title",
      subtitle: "brands.ksurgery.subtitle",
      description: "brands.ksurgery.description",
      description2: "brands.ksurgery.description2",
      description3: "brands.ksurgery.description3",
      whatIs: "brands.ksurgery.what",
      whatIsDescription: "brands.ksurgery.what.description",
      keyBenefits: "brands.ksurgery.keyBenefits",
      keyBenefit1: "brands.ksurgery.keyBenefit1",
      keyBenefit2: "brands.ksurgery.keyBenefit2",
      keyBenefit3: "brands.ksurgery.keyBenefit3",
      howIs: "brands.ksurgery.how.is",
      howIsDescription: "brands.ksurgery.how.is.description",
      results: "brands.ksurgery.results",
      result1: "brands.ksurgery.result1",
      result2: "brands.ksurgery.result2",
      result3: "brands.ksurgery.result3",
      application: "brands.ksurgery.application",
      applicationDescription: "brands.ksurgery.application.description",
      products: [
        {
          face: [
            {
              title: "brands.ksurgery.products.collection1.face1.title",
              subtitle: "brands.ksurgery.products.collection1.face1.subtitle",
              description:
                "brands.ksurgery.products.collection1.face1.description",
              buttonTitle:
                "brands.ksurgery.products.collection1.face1.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.face1.item1",
                "brands.ksurgery.products.collection1.face1.item2",
                "brands.ksurgery.products.collection1.face1.item3",
                "brands.ksurgery.products.collection1.face1.item4",
              ],
            },
            {
              title: "brands.ksurgery.products.collection1.face2.title",
              subtitle: "brands.ksurgery.products.collection1.face2.subtitle",
              description:
                "brands.ksurgery.products.collection1.face2.description",
              buttonTitle:
                "brands.ksurgery.products.collection1.face2.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.face2.item1",
                "brands.ksurgery.products.collection1.face2.item2",
                "brands.ksurgery.products.collection1.face2.item3",
                "brands.ksurgery.products.collection1.face2.item4",
              ],
            },
            {
              title: "brands.ksurgery.products.collection1.face3.title",
              subtitle: "brands.ksurgery.products.collection1.face3.subtitle",
              description:
                "brands.ksurgery.products.collection1.face3.description",
              buttonTitle:
                "brands.ksurgery.products.collection1.face3.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.face3.item1",
                "brands.ksurgery.products.collection1.face3.item2",
                "brands.ksurgery.products.collection1.face3.item3",
                "brands.ksurgery.products.collection1.face3.item4",
              ],
            },
            {
              title: "brands.ksurgery.products.collection1.face4.title",
              subtitle: "brands.ksurgery.products.collection1.face4.subtitle",
              description:
                "brands.ksurgery.products.collection1.face4.description",
              buttonTitle:
                "brands.ksurgery.products.collection1.face4.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.face4.item1",
                "brands.ksurgery.products.collection1.face4.item2",
                "brands.ksurgery.products.collection1.face4.item3",
                "brands.ksurgery.products.collection1.face4.item4",
              ],
            },
          ],
          body: [
            {
              title: "brands.ksurgery.products.collection1.body1.title",
              subtitle: "brands.ksurgery.products.collection1.body1.subtitle",
              description:
                "brands.ksurgery.products.collection1.body1.description",
              description2:
                "brands.ksurgery.products.collection1.body1.description2",

              buttonTitle:
                "brands.ksurgery.products.collection1.body1.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.body1.item1",
                "brands.ksurgery.products.collection1.body1.item2",
                "brands.ksurgery.products.collection1.body1.item3",
                "brands.ksurgery.products.collection1.body1.item4",
              ],
            },
          ],
        },
        {
          face: [
            {
              title: "brands.ksurgery.products.collection2.face1.title",
              subtitle: "brands.ksurgery.products.collection2.face1.subtitle",
              description:
                "brands.ksurgery.products.collection2.face1.description",
              buttonTitle:
                "brands.ksurgery.products.collection2.face1.buttonTitle",
              items: [
                "brands.ksurgery.products.collection2.face1.item1",
                "brands.ksurgery.products.collection2.face1.item2",
                "brands.ksurgery.products.collection2.face1.item3",
                "brands.ksurgery.products.collection2.face1.item4",
              ],
            },
            {
              title: "brands.ksurgery.products.collection2.face2.title",
              subtitle: "brands.ksurgery.products.collection2.face2.subtitle",
              description:
                "brands.ksurgery.products.collection2.face2.description",
              buttonTitle:
                "brands.ksurgery.products.collection2.face2.buttonTitle",
              items: [
                "brands.ksurgery.products.collection2.face2.item1",
                "brands.ksurgery.products.collection2.face2.item2",
                "brands.ksurgery.products.collection2.face2.item3",
                "brands.ksurgery.products.collection2.face2.item4",
              ],
            },
          ],
          body: [
            {
              title: "brands.ksurgery.products.collection1.body1.title",
              subtitle: "brands.ksurgery.products.collection1.body1.subtitle",
              description:
                "brands.ksurgery.products.collection1.body1.description",
              description2:
                "brands.ksurgery.products.collection1.body1.description2",

              buttonTitle:
                "brands.ksurgery.products.collection1.body1.buttonTitle",
              items: [
                "brands.ksurgery.products.collection1.body1.item1",
                "brands.ksurgery.products.collection1.body1.item2",
                "brands.ksurgery.products.collection1.body1.item3",
                "brands.ksurgery.products.collection1.body1.item4",
              ],
            },
          ],
        },
      ],
      skinbosoter: "brands.ksurgery.skinboster",
      skinbooster1: "brands.ksurgery.skinboster1",
      skinboosterTitle1: "brands.ksurgery.skinbosterTitle1",
      benefits: {
        title: "brands.ksurgery.benefits.title",
        description: "brands.ksurgery.benefits.description",
        item1: "brands.ksurgery.benefits.item1",
        item2: "brands.ksurgery.benefits.item2",
        item3: "brands.ksurgery.benefits.item3",
        item4: "brands.ksurgery.benefits.item4",
        item5: "brands.ksurgery.benefits.item5",
        item6: "brands.ksurgery.benefits.item6",
      },
      opera: "brands.ksurgery.opera",
      operaDescription: "brands.ksurgery.operaDescription",
      operaDescription1: "brands.ksurgery.operaDescription1",
      operaDescription2: "brands.ksurgery.operaDescription2",
    },
    renee: {
      buttonText:"brands.renee.buttonText",

      title: "brands.renee.title",
      subtitle: "brands.renee.subtitle",
      description: "brands.renee.description",
      description2: "brands.renee.description2",
      whatIs: "brands.renee.what",
      whatIsDescription: "brands.renee.what.description",
      keyBenefits: "brands.renee.keyBenefits",
      keyBenefit1: "brands.renee.keyBenefit1",
      keyBenefit2: "brands.renee.keyBenefit2",
      keyBenefit3: "brands.renee.keyBenefit3",
      howIs: "brands.renee.how.is",
      howIsDescription: "brands.renee.how.is.description",
      results: "brands.renee.results",
      result1: "brands.renee.result1",
      result2: "brands.renee.result2",
      result3: "brands.renee.result3",
      application: "brands.renee.application",
      applicationDescription: "brands.renee.application.description",
      products: [
        {
          skin: [
            {
              title: "brands.renee.products.collection1.skin1.title",
              subtitle: "brands.renee.products.collection1.skin1.subtitle",
              preQuestion:
                "brands.renee.products.collection1.skin1.preQuestion",
              question: "brands.renee.products.collection1.skin1.question",
              description:
                "brands.renee.products.collection1.skin1.description",
              buttonTitle:
                "brands.renee.products.collection1.skin1.buttonTitle",
              items: [
                "brands.renee.products.collection1.skin1.item1",
                "brands.renee.products.collection1.skin1.item2",
                "brands.renee.products.collection1.skin1.item3",
              ],
            },
            {
              title: "brands.renee.products.collection1.skin2.title",
              subtitle: "brands.renee.products.collection1.skin2.subtitle",
              question: "brands.renee.products.collection1.skin2.question",
              description:
                "brands.renee.products.collection1.skin2.description",
              buttonTitle:
                "brands.renee.products.collection1.skin2.buttonTitle",
              items: [
                "brands.renee.products.collection1.skin2.item1",
                "brands.renee.products.collection1.skin2.item2",
                "brands.renee.products.collection1.skin2.item3",
                "brands.renee.products.collection1.skin2.item4",
              ],
            },
            {
              title: "brands.renee.products.collection1.skin3.title",
              subtitle: "brands.renee.products.collection1.skin3.subtitle",
              question: "brands.renee.products.collection1.skin3.question",
              description:
                "brands.renee.products.collection1.skin3.description",
              buttonTitle:
                "brands.renee.products.collection1.skin3.buttonTitle",
              items: [
                "brands.renee.products.collection1.skin3.item1",
                "brands.renee.products.collection1.skin3.item2",
                "brands.renee.products.collection1.skin3.item3",
                "brands.renee.products.collection1.skin3.item4",
              ],
            },
            {
              title: "brands.renee.products.collection1.skin4.title",
              subtitle: "brands.renee.products.collection1.skin4.subtitle",
              question: "brands.renee.products.collection1.skin4.question",
              description:
                "brands.renee.products.collection1.skin4.description",
              buttonTitle:
                "brands.renee.products.collection1.skin4.buttonTitle",
              items: [
                "brands.renee.products.collection1.skin4.item1",
                "brands.renee.products.collection1.skin4.item2",
                "brands.renee.products.collection1.skin4.item3",
                "brands.renee.products.collection1.skin4.item4",
              ],
            },
            {
              title: "brands.renee.products.collection1.skin5.title",
              subtitle: "brands.renee.products.collection1.skin5.subtitle",
              question: "brands.renee.products.collection1.skin5.question",
              description:
                "brands.renee.products.collection1.skin5.description",
              buttonTitle:
                "brands.renee.products.collection1.skin5.buttonTitle",
              items: [
                "brands.renee.products.collection1.skin5.item1",
                "brands.renee.products.collection1.skin5.item2",
                "brands.renee.products.collection1.skin5.item3",
                "brands.renee.products.collection1.skin5.item4",
              ],
            },
          ],
        },
      ],
    },
    lenisna: {
      buttonText:"brands.lensina.buttonText",

      pageTitle: "brands.lenisna.pageTitle",
      pageDescription: "brands.lenisna.pageDescription",
      title: "brands.lenisna.title",
      subtitle: "brands.lenisna.subtitle",
      description: "brands.lenisna.description",
      description2: "brands.lenisna.description2",
      whatIs: "brands.lenisna.what",
      whatIsDescription: "brands.lenisna.what.description",
      keyBenefits: "brands.lenisna.keyBenefits",
      keyBenefit1: "brands.lenisna.keyBenefit1",
      keyBenefit2: "brands.lenisna.keyBenefit2",
      keyBenefit3: "brands.lenisna.keyBenefit3",
      howIs: "brands.lenisna.how.is",
      howIsDescription: "brands.lenisna.how.is.description",
      results: "brands.lenisna.results",
      result1: "brands.lenisna.result1",
      result2: "brands.lenisna.result2",
      result3: "brands.lenisna.result3",
      application: "brands.lenisna.application",
      applicationDescription: "brands.lenisna.application.description",
      products: [
        {
          title: "brands.renee.products.collection1.title",
          aging: [
            {
              title1: "brands.renee.products.collection1.aging1.title1",
              title2: "brands.renee.products.collection1.aging1.title2",
              title3: "brands.renee.products.collection1.aging1.title3",
              title4: "brands.renee.products.collection1.aging1.title4",
              description1:
                "brands.renee.products.collection1.aging1.description1",
              description2:
                "brands.renee.products.collection1.aging1.description2",
              description3:
                "brands.renee.products.collection1.aging1.description3",
              volumeItems: [
                "brands.renee.products.collection1.aging1.volumeItem1",
                "brands.renee.products.collection1.aging1.volumeItem2",
                "brands.renee.products.collection1.aging1.volumeItem3",
                "brands.renee.products.collection1.aging1.volumeItem4",
                "brands.renee.products.collection1.aging1.volumeItem5",
                "brands.renee.products.collection1.aging1.volumeItem6",
              ],
              items: [
                "brands.renee.products.collection1.aging1.item1",
                "brands.renee.products.collection1.aging1.item2",
                "brands.renee.products.collection1.aging1.item3",
              ],
            },
          ],
        },
      ],
      face: {
        title: "brands.lenisna.face.title",
        point1: "brands.lenisna.face.point1",
        point2: "brands.lenisna.face.point2",
        point3: "brands.lenisna.face.point3",
        point4: "brands.lenisna.face.point4",
        point5: "brands.lenisna.face.point5",
        point6: "brands.lenisna.face.point6",
        point7: "brands.lenisna.face.point7",
        point8: "brands.lenisna.face.point8",
      },
      body: {
        point1: "brands.lenisna.body.point1",
        point2: "brands.lenisna.body.point2",
        point3: "brands.lenisna.body.point3",
        point4: "brands.lenisna.body.point4",
        point5: "brands.lenisna.body.point5",
      },
    },
    juvelook: {
      buttonText:"brands.juvelook.buttonText",

      pageTitle: "brands.juvelook.pageTitle",
      pageDescription: "brands.juvelook.pageDescription",
      title: "brands.juvelook.title",
      subtitle: "brands.juvelook.subtitle",
      description: "brands.juvelook.description",
      description2: "brands.juvelook.description2",
      whatIs: "brands.juvelook.what",
      whatIsDescription: "brands.juvelook.what.description",
      keyBenefits: "brands.juvelook.keyBenefits",
      keyBenefit1: "brands.juvelook.keyBenefit1",
      keyBenefit2: "brands.juvelook.keyBenefit2",
      keyBenefit3: "brands.juvelook.keyBenefit3",
      howIs: "brands.juvelook.how.is",
      howIsDescription: "brands.juvelook.how.is.description",
      results: "brands.juvelook.results",
      result1: "brands.juvelook.result1",
      result2: "brands.juvelook.result2",
      result3: "brands.juvelook.result3",
      application: "brands.juvelook.application",
      applicationDescription: "brands.juvelook.application.description",
      products: [
        {
          title: "brands.juvelook.products.collection1.title",
          aging: [
            {
              title1: "brands.juvelook.products.collection1.aging1.title1",
              title2: "brands.juvelook.products.collection1.aging1.title2",
              title3: "brands.juvelook.products.collection1.aging1.title3",
              title4: "brands.juvelook.products.collection1.aging1.title4",
              description1:
                "brands.juvelook.products.collection1.aging1.description1",
              description2:
                "brands.juvelook.products.collection1.aging1.description2",
              description3:
                "brands.juvelook.products.collection1.aging1.description3",
              volumeItems: [
                "brands.juvelook.products.collection1.aging1.volumeItem1",
                "brands.juvelook.products.collection1.aging1.volumeItem2",
                "brands.juvelook.products.collection1.aging1.volumeItem3",
                "brands.juvelook.products.collection1.aging1.volumeItem4",
                "brands.juvelook.products.collection1.aging1.volumeItem5",
                "brands.juvelook.products.collection1.aging1.volumeItem6",
                "brands.juvelook.products.collection1.aging1.volumeItem7",
              ],
              items: [
                "brands.juvelook.products.collection1.aging1.item1",
                "brands.juvelook.products.collection1.aging1.item2",
                "brands.juvelook.products.collection1.aging1.item3",
              ],
            },
          ],
        },
      ],
      face: {
        title: "brands.juvelook.face.title",
        scar: "brands.juvelook.face.scar",
        stretch: "brands.juvelook.face.stretch",
        point1: "brands.juvelook.face.point1",
        point2: "brands.juvelook.face.point2",
        point3: "brands.juvelook.face.point3",
        point4: "brands.juvelook.face.point4",
        point5: "brands.juvelook.face.point5",
        point6: "brands.juvelook.face.point6",
        point7: "brands.juvelook.face.point7",
      },
    },


    dimono: {
      buttonText:"brands.dimono.buttonText",

      title: "brands.dimono.title",
      subtitle: "brands.dimono.subtitle",
      
      description: "brands.dimono.description",
      description2: "brands.dimono.description2",
      whatIs: "brands.dimono.what",
      whatIsDescription: "brands.dimono.what.description",
      product: {
        featuresTitle: "brands.dimono.product.featuresTitle",
        treatmentTitle: "brands.dimono.product.treatmentTitle",
        keyBenefitsTitle: "brands.dimono.product.keyBenefitsTitle",
        functionTitle: "brands.dimono.product.functionTitle",

        title: "brands.dimono.product.title",
        subtitle: "smoothing expression lines and enhancing skin texture",
        features: [
          { item1: "brands.dimono.product.features.item1" },
          "brands.dimono.product.features.item2",
          "brands.dimono.product.features.item3",
          "brands.dimono.product.features.item4",
        ],
        treatmentItems: [
          "brands.dimono.product.treatmentItems.item1",
          "brands.dimono.product.treatmentItems.item2",
          "brands.dimono.product.treatmentItems.item3",
        ],

        keyBenefitsItems: [
          "brands.dimono.product.keyBenefits.item1",
          "brands.dimono.product.keyBenefits.item2",
          "brands.dimono.product.keyBenefits.item3",
          "brands.dimono.product.keyBenefits.item4",
          "brands.dimono.product.keyBenefits.item5",
        ],

        functionItems: [
          "brands.dimono.product.function.item1",
          "brands.dimono.product.function.item2",
          "brands.dimono.product.function.item3",
        ],
      },
      productoverviewTitle: "brands.dimono.productoverviewTitle",
      productoverviewDesc: "brands.dimono.productoverviewDesc",


      applicationAreas:[
        "brands.dimono.applicationAreas[0]",
        "brands.dimono.applicationAreas[1]",
        "brands.dimono.applicationAreas[2]",
        "brands.dimono.applicationAreas[3]",
        "brands.dimono.applicationAreas[4]",
        "brands.dimono.applicationAreas[5]",
        "brands.dimono.applicationAreas[6]",
        "brands.dimono.applicationAreas[7]",
        "brands.dimono.applicationAreas[8]",
        "brands.dimono.applicationAreas[9]",
      ]


    },







    ellanse: {
      buttonText:"brands.ellanse.buttonText",

      title: "brands.ellanse.title",
      subtitle: "brands.ellanse.subtitle",
      description: "brands.ellanse.description",
       description2: "brands.ellanse.description2",
      // description3: "brands.ellanse.description3",
      whatIs: "brands.ellanse.whatIs",
      whatIsDescription: "brands.ellanse.whatIsDescription",


      box2Title: "brands.ellanse.box2Title",
      // box2Description: "brands.ellanse.box2Description",


      box2p1: "brands.ellanse.box2p1",
      box2p2: "brands.ellanse.box2p2",
      articlesTitle: "brands.ellanse.articlesTitle",
      articlesSubtitle: "brands.ellanse.articlesSubtitle",

      productoverviewTitle: "brands.ellanse.productoverviewTitle",
      productoverviewDesc: "brands.ellanse.productoverviewDesc",

      box3p1: "brands.ellanse.box3p1",
      articles: {
        title: "brands.ellanse.articles.title",
        subtitle: "brands.ellanse.articles.subtitle",
        items: [
          {
            title: "brands.ellanse.articles.items[0].title",
            description: "brands.ellanse.articles.items[0].description"
          },
          {
            title: "brands.ellanse.articles.items[1].title",
            description: "brands.ellanse.articles.items[1].description"
          },
          {
            title: "brands.ellanse.articles.items[2].title",
            description: "brands.ellanse.articles.items[2].description"
          },
        ]
      }
    },

    lanluma: {
      buttonText:"brands.lanluma.buttonText",

      title: "brands.lanluma.title",
      subtitle: "brands.lanluma.subtitle",
      description: "brands.lanluma.description",
       description2: "brands.lanluma.description2",
      // description3: "brands.lanluma.description3",
      whatIs: "brands.lanluma.whatIs",
      whatIsDescription: "brands.lanluma.whatIsDescription",


      box2Title: "brands.lanluma.box2Title",
      // box2Description: "brands.lanluma.box2Description",


      box2p1: "brands.lanluma.box2p1",
      box2p2: "brands.lanluma.box2p2",
      articlesTitle: "brands.lanluma.articlesTitle",
      articlesSubtitle: "brands.lanluma.articlesSubtitle",

      productoverviewTitle: "brands.lanluma.productoverviewTitle",
      productoverviewDesc: "brands.lanluma.productoverviewDesc",

      box3p1: "brands.lanluma.box3p1",
      articles: {
        title: "brands.lanluma.articles.title",
        subtitle: "brands.lanluma.articles.subtitle",
        items: [
          {
            title: "brands.lanluma.articles.items[0].title",
            description: "brands.lanluma.articles.items[0].description"
          },
          {
            title: "brands.lanluma.articles.items[1].title",
            description: "brands.lanluma.articles.items[1].description"
          },
          {
            title: "brands.lanluma.articles.items[2].title",
            description: "brands.lanluma.articles.items[2].description"
          },
        ]
      }
    },




    maili: {
      buttonText:"brands.maili.buttonText",

      title: "brands.maili.title",
      subtitle: "brands.maili.subtitle",
      description: "brands.maili.description",
       description2: "brands.maili.description2",
      // description3: "brands.maili.description3",
      whatIs: "brands.maili.whatIs",
      whatIsDescription: "brands.maili.whatIsDescription",


      box2Title: "brands.maili.box2Title",
      // box2Description: "brands.maili.box2Description",


      box2p1: "brands.maili.box2p1",
      box2p2: "brands.maili.box2p2",
      articlesTitle: "brands.maili.articlesTitle",
      articlesSubtitle: "brands.maili.articlesSubtitle",

      productoverviewTitle: "brands.maili.productoverviewTitle",
      productoverviewDesc: "brands.maili.productoverviewDesc",

      // box3p1: "brands.maili.box3p1",
      articles: {
        title: "brands.maili.articles.title",
        subtitle: "brands.maili.articles.subtitle",
        items: [
          {
            title: "brands.maili.articles.items[0].title",
            description: "brands.maili.articles.items[0].description"
          },
          {
            title: "brands.maili.articles.items[1].title",
            description: "brands.maili.articles.items[1].description"
          },
          {
            title: "brands.maili.articles.items[2].title",
            description: "brands.maili.articles.items[2].description"
          },
        ]
      }
    },

    drcyj: {
      buttonText:"brands.drcyj.buttonText",
      title: "brands.drcyj.title",
      subtitle: "brands.drcyj.subtitle",
      description: "brands.drcyj.description",
      description2: "brands.drcyj.description2",
      whatIs: "brands.drcyj.what",
      whatIsDescription: "brands.drcyj.what.description",
      product: {
        featuresTitle: "brands.drcyj.product.featuresTitle",
        treatmentTitle: "brands.drcyj.product.treatmentTitle",
        keyBenefitsTitle: "brands.drcyj.product.keyBenefitsTitle",
        functionTitle: "brands.drcyj.product.functionTitle",

        title: "brands.drcyj.product.title",
        subtitle: "brands.drcyj.product.subtitle",
        features: [
          { item1: "brands.drcyj.product.features.item1" },
          "brands.drcyj.product.features.item2",
          "brands.drcyj.product.features.item3",
          "brands.drcyj.product.features.item4",
        ],
        treatmentItems: [
          "brands.drcyj.product.treatmentItems.item1",
          "brands.drcyj.product.treatmentItems.item2",
          "brands.drcyj.product.treatmentItems.item3",
        ],

        keyBenefitsItems: [
          "brands.drcyj.product.keyBenefits.item1",
          "brands.drcyj.product.keyBenefits.item2",
          "brands.drcyj.product.keyBenefits.item3",
          "brands.drcyj.product.keyBenefits.item4",
          "brands.drcyj.product.keyBenefits.item5",
        ],

        functionItems: [
          "brands.drcyj.product.function.item1",
          "brands.drcyj.product.function.item2",
          "brands.drcyj.product.function.item3",
        ],
      },
      productoverviewTitle: "brands.drcyj.productoverviewTitle",
      productoverviewDesc: "brands.drcyj.productoverviewDesc",


      applicationAreas:[
        "brands.drcyj.applicationAreas[0]",
        "brands.drcyj.applicationAreas[1]",
        "brands.drcyj.applicationAreas[2]",
        "brands.drcyj.applicationAreas[3]",
        "brands.drcyj.applicationAreas[4]",
        "brands.drcyj.applicationAreas[5]",
        "brands.drcyj.applicationAreas[6]",
        "brands.drcyj.applicationAreas[7]",
        "brands.drcyj.applicationAreas[8]",
        "brands.drcyj.applicationAreas[9]",
      ]


    },


  },
};
